import { useQuery } from '@tanstack/react-query';
import { RQAPICall, RQAPICallWithData } from 'store/APIClient';
import { SupportDashboardT } from '../../../models';
import { useBaseSupportMutation } from '../../ClientSupport/components/ClientConfiguration/hooks/baseMutation';

export const useGetDashboards = (bind: string | undefined) =>
    useQuery({
        queryKey: ['support-dashboards', bind],

        queryFn: async () => {
            const response = await RQAPICallWithData<SupportDashboardT[]>({
                endpoint: `support/${bind}/dashboards`,
                method: 'GET',
            });
            return response.content.data;
        },

        enabled: !!bind,
    });

export const useTransferDashboard = () =>
    useBaseSupportMutation(
        (payload: {
            sourceBind: string;
            sourceDashboardKey: number;
            targetBind: string;
            targetUserId: number;
            isTemplate: boolean;
            isTutorial: boolean;
        }) =>
            RQAPICall({
                endpoint: `support/${payload.sourceBind}/dashboard/${payload.sourceDashboardKey}/import`,
                body: payload,
                method: 'POST',
            }),
    );
